<template>
  <div>
    <div class="outline">
      <header class="light outline">
        <h5 style="padding:7px 0;">Add Credit / Debit Card</h5>
      </header>
      <div class='credit-card-inputs w3-white' :class='{ complete }'>
        <div class="w3-row" style="padding:5px 5px 0;">
          <div class="w3-rest" style="margin-bottom:5px;" >
            <label>Card Number</label>
            <card-number class='stripe-element card-number' ref='cardNumber' :stripe='stripe' :options='options' @change='number = $event.complete' />
          </div>
        </div>
        <div class="w3-row" style="padding:0 5px;">
          <div class="w3-half" style="margin-bottom:5px; padding-right:5px;">
            <label>Expires</label>
            <card-expiry class='stripe-element card-expiry' ref='cardExpiry' :stripe='stripe' :options='options' @change='expiry = $event.complete' />
          </div>
          <div class="w3-half" style="margin-bottom:5px;">
            <label>CVC</label>
            <card-cvc class='stripe-element card-cvc' ref='cardCvc' :stripe='stripe' :options='options' @change='cvc = $event.complete' />
          </div>
        </div>
        <div class="w3-row" style="padding:0 5px 5px;">
          <div class="w3-rest">
            <label>Zip Code</label>
            <postal-code class='stripe-element postal-code' ref='postalCode' :stripe='stripe' :options='options' @change='zip = $event.complete' />
          </div>
        </div>
      </div>
    </div>
    <button class="w3-button w3-block w3-green w3-margin-top" :disabled='!complete' @click="addCard()">Save Card</button>
  </div>
</template>

<script>
import { CardNumber, CardExpiry, CardCvc, PostalCode, createToken } from 'vue-stripe-elements-plus'
import axios from 'axios'
var dataStore = require('../dataStore').default

export default {
  name: 'credit-card',
  data () {
    return {
      state: dataStore.state,
      // stripe: 'pk_test_L2d54QCXKYqqfeTk5AUcogPV', // DEV
      stripe: 'pk_live_wXn3WRGXzqtcmIwPC69nFZuR', // LIVE
      options: {
        style: {
          base: {
            color: '#212121',
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: 'antialiased',
            fontSize: '16px',
            '::placeholder': {
              color: '#999'
            }
          },
          invalid: {
            color: '#fa755a',
            iconColor: '#fa755a'
          }
        }
      },
      card: {
        default: false
      },
      complete: false,
      number: false,
      expiry: false,
      cvc: false,
      zip: false
    }
  },
  components: { CardNumber, CardExpiry, CardCvc, PostalCode },
  methods: {
    addCard() {
      let defaultCard = true
      if (this.state.user.stripeData.sources.data.length > 0) {
        defaultCard = false
      }
      createToken().then(data => {
        let postData = {
          stripeid: this.state.user.stripeid,
          token: data.token.id
        }
        axios.post(this.state.mainURL + '?customer=addStripeCard', postData, {headers: this.state.authHeader}).then((response) => {
          let card = response.data.data
          console.log(card)
          dataStore.addCard(response.data.data)
          if (defaultCard) {
            dataStore.updateStripeDefaultSource(card.id)
          }
          this.$emit('changeView', false)
        }).catch((error) => {
          console.log(error)
          this.state.error = error.data
        })
      })
    },
    update () {
      this.complete = this.number && this.expiry && this.cvc && this.zip
      // field completed, find field to focus next
      if (this.number) {
        if (!this.expiry) {
          this.$refs.cardExpiry.focus()
        } else if (!this.cvc) {
          this.$refs.cardCvc.focus()
        } else if (!this.zip) {
          this.$refs.postalCode.focus()
        }
      } else if (this.expiry) {
        if (!this.cvc) {
          this.$refs.cardCvc.focus()
        } else if (!this.zip) {
          this.$refs.postalCode.focus()
        } else if (!this.number) {
          this.$refs.cardNumber.focus()
        }
      } else if (this.zip) {
        if (!this.number) {
          this.$refs.cardNumber.focus()
        } else if (!this.cvc) {
          this.$refs.cardCvc.focus()
        } else if (!this.expiry) {
          this.$refs.cardExpiry.focus()
        }
      }
    }
  },
  watch: {
    number () { this.update() },
    expiry () { this.update() },
    cvc () { this.update() },
    zip () { this.update() }
  },
  created() {
    this.card.number = '4242424242424242'
  }
}
</script>

<style>
  .StripeElement {
    height: 40px;
    padding: 10px 12px;
    background:#f5f5f5;
  }
</style>
<style scoped>
  header {padding:8px 12px;}
  .rightButton {padding:6px 10px;}
</style>



// WEBPACK FOOTER //
// src/components/creditCard.vue